import React, { useEffect, useState } from "react";
import CustomDropdown from "../../components/CustomDropdown";
import {
	Box,
	Flex,
	Avatar,
	Input,
	Textarea,
	FormControl,
	FormLabel,
	Button,
	VStack,
	Switch,
	Select,
	HStack,
	Slider,
	SliderTrack,
	SliderFilledTrack,
	SliderThumb,
	Spinner,
	IconButton,
	Image,
} from "@chakra-ui/react";
import {
	GettingAllModels,
	GettingAllTools,
	updatedAgentApi,
} from "../../allApi/api";
import { useDispatch } from "react-redux";
import {
	waveflowclearefetchagentsData,
	waveFlowdataUpdate,
} from "../../redux/reducer/waveFlow";
import { useSelector } from "react-redux";
import { CheckIcon } from "@chakra-ui/icons";
import exstractIcon from "../../assets/waveflowmain/exstractIcon.png";
import ToolsList from "./tools/DropCardTools/ToolsList";
import { useCustomTost } from "../../utiils/useCustomTost";
import { fetchModels, fetchTools } from "../../redux/reducer/toolsmodel";

const AICoWorkerCard = ({ node }) => {
	const [showAdvanced, setShowAdvanced] = useState(false);
	const [showExstraItem, setshowExstraItem] = useState(false);
	const [updatedLoder, setUpdateLoader] = useState(false);
	const [updateSuccess, setupdateSuccess] = useState(false);
	const toast = useCustomTost();
	const dispatch = useDispatch();
	const { toolFetched, modelFetched, toolsList, loading, modelList } =
		useSelector((state) => state?.toolModelData);
	const waveFlowDelete = useSelector(
		(state) => state?.waveflowSearchData?.waveFlowDelete
	);

	useEffect(() => {
		if (!modelFetched) {
			dispatch(fetchModels());
		}

		if (!toolFetched) {
			dispatch(fetchTools());
		}
	}, [toolFetched, modelFetched, dispatch]);

	const waveflowModels =
		modelList?.map((item) => ({
			id: item?.id,
			modelName: item?.model_name,
		})) || [];

	const waveflowTools =
		toolsList?.map((item) => ({
			id: item.id,
			toolName: item?.function?.name,
			displayName: item?.display_name,
		})) || [];

	const [formData, setFormData] = useState({
		id: node.id,
		name: node.name,
		description: node?.description,
		role: node?.role,
		webSearch: node?.web_assist || false,
		type: node?.type,
		enums: "",
		model: {
			api_key:
				node?.model?.api_key ||
				"6c64d90b6a20150b30c4a643f9b104a2135c8445f94b20ffecb8832b7ee4302a",
			base_url: node?.model?.base_url || "http://dummy.com",
			client: node?.model?.client || "together",
			date: "26th December, 2024",
			description: node?.model?.description || "openAI",
			id: node?.model?.id || "bab17426-341f-4256-87da-bf94bc3e4ae4",
			model_name:
				node?.model?.model_name ||
				"meta-llama/Meta-Llama-3.1-8B-Instruct-Turbo",
		},
		tool:
			node?.tools?.length > 0 && node?.tools?.[0]?.function?.name
				? node?.tools
				: node?.tools?.[0]?.toolType == "PreDefined"
				? node?.tools
				: [],
		advanced_parameters: {
			max_tokens: node?.advanced_parameters?.max_tokens || 1000,
			temperature: node?.advanced_parameters?.temperature || 0.3,
			top_p: node?.advanced_parameters?.top_p || 0.9,
		},
		file_name: "agents",
	});

	const [executerFormData, setexecuterFormData] = useState({
		id: node.id,
		name: node.name,
		type: node?.type,
		tool:
			node?.tools?.length > 0 && node?.tools?.[0]?.function?.name
				? // ? [
				  //     {
				  //       id: node?.tools?.id || "",
				  //       function: {
				  //         name: node?.tools?.[0]?.function?.name || "",
				  //       },
				  //     },
				  //   ]
				  node?.tools
				: [],
		description: "",
	});

	const [dicisionFormData, setdicisionFormData] = useState({
		id: node.id,
		name: node.name,
		type: node?.type,
		description: "",
	});

	const handleSliderChange = (name, value) => {
		setFormData((prev) => ({
			...prev,
			advanced_parameters: {
				...prev.advanced_parameters,
				[name]: value,
			},
		}));
	};
	const [enumListStatus, setEnumListStatus] = useState("");

	const handleChange = (e, toolsStatus, enumList) => {
		const { name, value, type, checked } = e.target;
		let storeToolName;
		if (name == "tool" && !enumList) {
			storeToolName = value;
			setEnumListStatus(value);
		}

		setFormData((prev) => {
			if (name === "model") {
				const selectedModel =
					modelList?.find((item) => item.id === value) || null;
				return {
					...prev,
					model: selectedModel,
				};
			}

			if (name === "tool") {
				if (toolsStatus && !enumList) {
					return {
						...prev,
						tool: [
							{
								name: value,
								toolType: "PreDefined",
							},
						],
					};
				}
				if (toolsStatus && enumList == "enumList") {
					return {
						...prev,
						tool: [
							{
								name: enumListStatus,
								toolType: "PreDefined",
								enums: value,
							},
						],
					};
				}
				if (value === "None") {
					return {
						...prev,
						tool: [],
					};
				}

				const selectedTool =
					toolsList?.find((item) => item.id === value) || null;
				return {
					...prev,
					tool: selectedTool ? [selectedTool] : [],
				};
			}

			return {
				...prev,
				[name]: type === "checkbox" ? checked : value,
			};
		});
	};

	const handleChangeForExecuter = (e) => {
		const { name, value, type, checked } = e.target;

		setexecuterFormData((prev) => {
			if (name === "tool") {
				if (value === "None") {
					return { ...prev, tool: [] };
				}
				const selectedTool =
					toolsList?.find((item) => item.id === value) || null;
				return { ...prev, tool: selectedTool ? [selectedTool] : [] };
			}

			return {
				...prev,
				[name]: value,
				// name === "description"
				//   ? checkAndParseJSON(value, prev.description)
				//   : type === "checkbox"
				//   ? checked
				//   : value,
			};
		});
	};

	//!decision formadata
	const handleChangeDecision = (e) => {
		const { name, value, type, checked } = e.target;

		setdicisionFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const toggleAdvancedOptions = () => {
		setShowAdvanced(!showAdvanced);
	};

	const toggleshowExstraItem = () => {
		setshowExstraItem(!showExstraItem);
	};

	const handleUpdate = async () => {
		if (
			formData?.tool[0]?.toolType == "PreDefined" &&
			!formData?.tool[0]?.enums
		) {
			toast("Warning!", "Please select action enum for tool.", "warning");
			return;
		}

		setUpdateLoader(true);

		try {
			const response = await updatedAgentApi(formData);
			setFormData({
				...formData,
			});

			if (!response?.agent) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			if (response?.agent) {
				dispatch(waveFlowdataUpdate(response?.agent));
				dispatch(waveflowclearefetchagentsData());
				setFormData({
					...formData,
				});
				setupdateSuccess(true);
			}
		} catch (error) {
			console.error("Error updating data:", error);
		} finally {
			setUpdateLoader(false);
			setTimeout(() => {
				setupdateSuccess(false);
			}, 1000);
		}
	};

	const handleUpdateExcuter = async () => {
		setUpdateLoader(true);
		try {
			const response = await updatedAgentApi(executerFormData);
			setexecuterFormData({
				...executerFormData,
			});
			if (response?.error) {
				toast("Warning!", response?.error, "warning");

				return;
			}

			if (!response?.["execution node"]) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			if (response?.["execution node"]) {
				dispatch(waveFlowdataUpdate(response?.["execution node"]));
				dispatch(waveflowclearefetchagentsData());
				setexecuterFormData({
					...executerFormData,
				});
				setupdateSuccess(true);
			}
		} catch (error) {
			console.error("Error updating data:", error);
		} finally {
			setUpdateLoader(false);
			setTimeout(() => {
				setupdateSuccess(false);
			}, 1000);
		}
	};

	const handleUpdateDecision = async () => {
		setUpdateLoader(true);
		try {
			const response = await updatedAgentApi(dicisionFormData);
			setdicisionFormData({
				...dicisionFormData,
			});

			if (!response?.["decision node"]) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			if (response?.["decision node"]) {
				dispatch(waveFlowdataUpdate(response?.["decision node"]));
				dispatch(waveflowclearefetchagentsData());
				setdicisionFormData({
					...dicisionFormData,
				});
				setupdateSuccess(true);
			}
		} catch (error) {
			console.error("Error updating data:", error);
		} finally {
			setUpdateLoader(false);
			setTimeout(() => {
				setupdateSuccess(false);
			}, 1000);
		}
	};

	{
		return node?.type == "executor node" ? (
			<Box
				w="300px"
				border={"transparent"}
				p="2"
				borderRadius="20px"
				bgGradient="linear(to-r, #E8DCFC, #CDBAF2)"
				color="gray.800"
				// bg="#d9d2e9"
			>
				<Flex align="center" justify="space-between" mb={2} gap={2}>
					<Avatar color={"white"} bg={"#7D73FE"} size="sm" name={node.name} />

					<Input
						name="name"
						fontWeight={500}
						value={executerFormData.name}
						onChange={handleChangeForExecuter}
						bg={"gray.200"}
						placeholder="Enter name"
						size={"sm"}
					/>
				</Flex>

				<VStack align="stretch">
					<FormControl>
						<HStack justifyContent={"space-between"}>
							<FormLabel>Tools</FormLabel>
							<Select
								name="tool"
								value={executerFormData?.tool || "None"}
								onChange={handleChangeForExecuter}
								width="100%"
								bg={"rgba(238, 241, 243, 1)"}
								w={"70%"}
								size={"sm"}
							>
								<option value={executerFormData?.tool[0]?.display_name} hidden>
									{executerFormData?.tool[0]?.display_name || "None"}
								</option>
								<option value={"None"}>None</option>
								{waveflowTools &&
									waveflowTools.map((ele) => (
										<option key={ele?.id} value={ele?.id}>
											{ele?.displayName}
										</option>
									))}
							</Select>
						</HStack>
					</FormControl>

					<FormControl isRequired>
						<FormLabel>Parameters</FormLabel>
						<Textarea
							name="description"
							value={executerFormData.description}
							onChange={handleChangeForExecuter}
							minH={"100px"}
							placeholder='{"key":"value"}'
							bg={"rgba(238, 241, 243, 1)"}
						/>
					</FormControl>
				</VStack>

				<Button
					mt="2"
					colorScheme="blue"
					onClick={handleUpdateExcuter}
					w="100%"
				>
					{updatedLoder ? (
						<>
							<Spinner size="sm" mr="10px" />
							Updating
						</>
					) : (
						<>
							{!updateSuccess && "Update"}
							{updateSuccess && (
								<>
									<Box
										// position="absolute"
										// top="50%"
										// right="50px"
										transform="translateY(0%)"
										animation="fadeIn 0.3s ease-in-out"
										bg={"green"}
										p={1}
										borderRadius={"20px"}
									>
										<CheckIcon color="white" />
									</Box>
								</>
							)}
						</>
					)}
				</Button>
			</Box>
		) : node?.type == "decision node" ? (
			<Box
				w="300px"
				border={"transparent"}
				p="2"
				borderRadius="20px"
				bg="white"
			>
				<Flex align="center" justify="space-between">
					<Flex align="center" gap={2}>
						<Avatar
							color={"white"}
							bg={"#7D73FE"}
							size="sm"
							name={dicisionFormData?.name}
						/>

						<Input
							name="name"
							fontWeight={500}
							value={dicisionFormData?.name}
							onChange={handleChangeDecision}
							bg={"rgba(238, 241, 243, 1)"}
							placeholder="Enter name"
							size={"sm"}
						/>
					</Flex>
				</Flex>

				<VStack align="stretch" mb={2}>
					<FormControl isRequired>
						<FormLabel>Node description</FormLabel>
						<Textarea
							name="description"
							value={dicisionFormData?.description}
							onChange={handleChangeDecision}
							minH={"100px"}
							placeholder="Enter description"
							bg={"rgba(238, 241, 243, 1)"}
						/>
					</FormControl>
					<FormControl mb={1}>
						<FormLabel>Labels</FormLabel>

						{/* {formData.secrets.map((secret, index) => ( */}
						<HStack spacing={2} w={"100%"}>
							<Input
								placeholder="Key"
								name="key"
								value={dicisionFormData?.dicisionFormkey}
								onChange={handleChangeDecision}
								size={"sm"}
							/>
							<Input
								placeholder="Value"
								name="secretKey"
								type="password"
								value={dicisionFormData?.secretKey}
								onChange={handleChangeDecision}
								size={"sm"}
							/>
						</HStack>
					</FormControl>
				</VStack>

				<Button
					mt="2"
					colorScheme="blue"
					onClick={handleUpdateDecision}
					w="100%"
				>
					{updatedLoder ? (
						<>
							<Spinner size="sm" mr="10px" />
							Updating
						</>
					) : (
						<>
							{!updateSuccess && "Update"}
							{updateSuccess && (
								<>
									<Box
										// position="absolute"
										// top="50%"
										// right="50px"
										transform="translateY(0%)"
										animation="fadeIn 0.3s ease-in-out"
										bg={"green"}
										p={1}
										borderRadius={"20px"}
									>
										<CheckIcon color="white" />
									</Box>
								</>
							)}
						</>
					)}
				</Button>
			</Box>
		) : (
			//! this is for agent
			<Box
				w="300px"
				border={"transparent"}
				p="2"
				borderRadius="20px"
				bg="white"
				fontSize="14px"
			>
				<Flex align="center" justify="space-between">
					<Flex align="center" gap={1}>
						<Avatar color={"white"} bg={"#7D73FE"} size="sm" name={node.name} />

						<Input
							name="name"
							fontSize="18px"
							fontWeight={500}
							value={formData.name}
							onChange={handleChange}
							bg={"gray.200"}
							placeholder="Enter name"
							size={"sm"}
							borderRadius={"md"}
							w={"75%"}
						/>
					</Flex>
					<HStack justifyContent={"space-between"}>
						<FormControl display="flex" alignItems="center">
							<Switch
								isChecked={formData?.webSearch}
								onChange={handleChange}
								colorScheme="blue"
								name="webSearch"
								fontSize="12px"
								size={"md"}
								mb={0}
								bg={"rgba(238, 241, 243, 1)"}
							/>
						</FormControl>

						<IconButton
							aria-label="Profile"
							icon={<Image src={exstractIcon} w={"16px"} />}
							bg={"transparent"}
							size={"sm"}
							onClick={toggleshowExstraItem}
						/>
					</HStack>
				</Flex>

				<VStack align="stretch" mb={1}>
					<FormControl fontSize="14px" isRequired>
						<HStack justifyContent={"space-between"}>
							<FormLabel
								fontSize="14px"
								mb={0}
								color={"rgba(108, 114, 117, 0.75)"}
							>
								Persona
							</FormLabel>
						</HStack>
						<Input
							mb={0}
							name="role"
							fontSize="18px"
							value={formData.role}
							onChange={handleChange}
							placeholder="Enter role"
							bg={"gray.200"}
							size={"sm"}
							borderRadius={"md"}
						/>
					</FormControl>

					<FormControl isRequired>
						<FormLabel
							mb={0}
							fontSize="14px"
							color={"rgba(108, 114, 117, 0.75)"}
						>
							Description
						</FormLabel>
						<Textarea
							name="description"
							fontSize="18px"
							mb={0}
							value={formData.description}
							onChange={handleChange}
							minH={"150px"}
							placeholder="Enter description"
							bg={"gray.200"}
							style={{
								overflowY: "auto",
								border: "black",
							}}
						/>
					</FormControl>
				</VStack>
				{showExstraItem && (
					<>
						<VStack justify={"flex-start"}>
							<FormControl mb={0} isRequired>
								<FormLabel
									mb={0}
									fontSize="14px"
									color={"rgba(108, 114, 117, 0.75)"}
								>
									Model
								</FormLabel>
									{/* <Select
									mb={0}
									name="model"
									fontSize="18px"
									// ✅ FIX: Pass the specific ID, not the whole object
									value={formData?.model?.id || ""}
									onChange={handleChange}
									width="100%"
									placeholder="Select a model" 
									bg={"gray.200"}
									size={"sm"}
								>
									{waveflowModels &&
										waveflowModels.map((ele) => (
											<option value={ele?.id}>{ele?.modelName}</option>
										))}
								</Select> */}

								<Select
									mb={0}
									name="model"
									fontSize="18px"
									// value={formData?.model} // This was there previously
									value={formData?.model?.id || ""}
									onChange={handleChange}
									width="100%"
									// 2. Placeholder appears only if NO model is selected
									// placeholder="Select a model"
									bg={"gray.200"}
									size={"sm"}
								>
									{/* 3. SAFETY CHECK: 
									If a model is selected but NOT in the list (e.g., list loading or custom model),
									we render a hidden option so the box displays the name correctly instead of being blank.
									*/}
									{formData?.model?.id && 
									!waveflowModels.some((m) => m.id === formData.model.id) && (
										<option value={formData.model.id} hidden>
											{formData.model.model_name || "Current Model"}
										</option>
									)}

									{/* 4. Render all API models */}
									{waveflowModels &&
										waveflowModels.map((ele) => (
											<option key={ele?.id} value={ele?.id}>
												{ele?.modelName}
											</option>
										))}
								</Select>
							</FormControl>

							{/* <FormControl mb={0} isRequired>
                <FormLabel
                  mb={0}
                  fontSize="14px"
                  color={"rgba(108, 114, 117, 0.75)"}
                >
                  Model
                </FormLabel>

                <CustomDropdown
                  options={waveflowModels.map((model) => ({
                    label: model.modelName,
                    value: model.id,
                  }))}
                  value={formData?.model?.id || ""}
                  onChange={(selectedModelId) => {
                    const selectedModel = waveflowModels.find(
                      (model) => model.id === selectedModelId
                    );
                    if (selectedModel) {
                      setFormData((prev) => ({
                        ...prev,
                        model: selectedModel,
                      }));
                    }
                  }}
                  placeholder="Select a model"
                  isLoading={loading}
                />
              </FormControl> */}

							<ToolsList
								handleChange={handleChange}
								formData={formData}
								waveflowTools={waveflowTools}
							/>

							{/* <NestedDropdown/> */}

							{/* <FormControl display="flex" alignItems="center">
                <FormLabel
                  fontSize="14px"
                  color={"rgba(108, 114, 117, 0.75)"}
                  mb="0"
                >
                  Web Assist
                </FormLabel>
                <Switch
                  isChecked={formData?.webSearch}
                  onChange={handleChange}
                  colorScheme="blue"
                  name="webSearch"
                  fontSize="14px"
                  mb={0}
                  bg={"rgba(238, 241, 243, 1)"}
                />
              </FormControl> */}
							<Button
								border="1px solid rgba(108, 177, 255, 1)"
								onClick={toggleAdvancedOptions}
								w="100%"
								fontSize="14px"
								py={0}
								size={"sm"}
								color="rgba(108, 177, 255, 1)"
							>
								{showAdvanced ? "More Options   ▲" : "More Options   ▼"}
							</Button>
						</VStack>
						{showAdvanced && (
							<VStack mt="1" align="stretch">
								<FormControl>
									<FormLabel
										mb={0}
										bg={"rgba(238, 241, 243, 1)"}
										fontSize="14px"
									>
										Output Length : {formData.advanced_parameters.max_tokens}
									</FormLabel>
									<Slider
										value={formData.advanced_parameters.max_tokens}
										onChange={(value) =>
											handleSliderChange("max_tokens", value)
										}
										min={100}
										mb={0}
										max={4000}
									>
										<SliderTrack>
											<SliderFilledTrack />
										</SliderTrack>
										<SliderThumb />
									</Slider>
								</FormControl>

								<FormControl>
									<FormLabel
										mb={0}
										bg={"rgba(238, 241, 243, 1)"}
										fontSize="14px"
									>
										Temperature: {formData.advanced_parameters.temperature}
									</FormLabel>
									<Slider
										value={formData.advanced_parameters.temperature}
										onChange={(value) =>
											handleSliderChange("temperature", value)
										}
										mb={0}
										min={0}
										max={1}
										step={0.01}
									>
										<SliderTrack>
											<SliderFilledTrack />
										</SliderTrack>
										<SliderThumb />
									</Slider>
								</FormControl>

								<FormControl>
									<FormLabel
										mb={0}
										bg={"rgba(238, 241, 243, 1)"}
										fontSize="14px"
									>
										top_p : {formData.advanced_parameters.top_p}
									</FormLabel>
									<Slider
										value={formData.advanced_parameters.top_p}
										onChange={(value) => handleSliderChange("top_p", value)}
										min={0}
										max={1}
										step={0.01}
										mb={0}
									>
										<SliderTrack>
											<SliderFilledTrack />
										</SliderTrack>
										<SliderThumb />
									</Slider>
								</FormControl>
							</VStack>
						)}
					</>
				)}
				<Button mt="1" colorScheme="blue" onClick={handleUpdate} w="100%">
					{updatedLoder ? (
						<>
							<Spinner size="sm" mr="10px" />
							Updating
						</>
					) : (
						<>
							{!updateSuccess && "Update"}
							{updateSuccess && (
								<>
									<Box
										// position="absolute"
										// top="50%"
										// right="50px"
										transform="translateY(0%)"
										animation="fadeIn 0.3s ease-in-out"
										bg={"green"}
										borderRadius={"20px"}
									>
										<CheckIcon color="white" />
									</Box>
								</>
							)}
						</>
					)}
				</Button>
			</Box>
		);
	}
};

export default AICoWorkerCard;
